import { API_CONFIG } from '@/config/api';
import { apiFetch } from '@/lib/apiFetch';

const BASE = API_CONFIG.DEPOSIT_WITHDRAW_PATH_PREFIX.replace(/\/?$/, '');

export const DEPOSIT_WITHDRAW_EXCHANGES = [
  { value: 'bybit', label: 'Bybit' },
  { value: 'okx', label: 'OKX' },
  { value: 'binance', label: 'Binance' },
  { value: 'gateio', label: 'Gateio' },
  { value: 'bitget', label: 'Bitget' },
] as const;

export type DepositWithdrawExchange = (typeof DEPOSIT_WITHDRAW_EXCHANGES)[number]['value'];

export interface DepositWithdrawRow {
  coin: string;
  chain: string;
  deposit_enabled: boolean;
  withdraw_enabled: boolean;
}

export interface DepositWithdrawResponse {
  exchange: string;
  coin_filter: string | null;
  count: number;
  data: DepositWithdrawRow[];
}

export interface DepositWithdrawExchangeResult {
  exchange: string;
  count: number;
  data: DepositWithdrawRow[];
  error: string | null;
}

export interface DepositWithdrawAllResponse {
  coin_filter: string | null;
  exchanges: string[];
  success_count: number;
  error_count: number;
  total_rows: number;
  results: DepositWithdrawExchangeResult[];
}

export async function getDepositWithdrawStatus(
  exchange: DepositWithdrawExchange,
  coin: string
): Promise<DepositWithdrawResponse> {
  const normalizedCoin = coin.trim().toUpperCase();
  const q = new URLSearchParams();
  q.set('exchange', exchange);
  if (normalizedCoin) q.set('coin', normalizedCoin);

  const res = await apiFetch(`${BASE}/status?${q.toString()}`);
  if (!res.ok) {
    const text = await res.text();
    let message = text || `HTTP ${res.status}`;
    try {
      const parsed = JSON.parse(text) as { detail?: string };
      if (parsed.detail) message = parsed.detail;
    } catch {}
    throw new Error(message);
  }
  return (await res.json()) as DepositWithdrawResponse;
}

export async function getDepositWithdrawStatusAll(
  coin: string
): Promise<DepositWithdrawAllResponse> {
  const normalizedCoin = coin.trim().toUpperCase();
  const q = new URLSearchParams();
  if (normalizedCoin) q.set('coin', normalizedCoin);

  const suffix = q.toString();
  const url = suffix ? `${BASE}/status/all?${suffix}` : `${BASE}/status/all`;
  const res = await apiFetch(url);
  if (!res.ok) {
    const text = await res.text();
    let message = text || `HTTP ${res.status}`;
    try {
      const parsed = JSON.parse(text) as { detail?: string };
      if (parsed.detail) message = parsed.detail;
    } catch {}
    throw new Error(message);
  }
  return (await res.json()) as DepositWithdrawAllResponse;
}
